import React from "react"
import { Result } from "antd"
import { LockOutlined } from "@ant-design/icons"

const AppLoginOverlay = () => {
  return (
    <div className="fixed inset-0 bg-white z-50">
      <div className="h-screen w-screen flex items-center justify-center">
        <Result
          icon={<LockOutlined size={64} className="text-red-500" />}
          status="error"
          title="You cannot access system"
          subTitle="Please download our production app before you are trying to access"
        />
      </div>
    </div>
  )
}

export default AppLoginOverlay
